import { EvaluationFeedbackCalibration } from '@app/models/evaluation/evaluation-feedback-calibration.model';

export const mockEvaluationFeedbackCalibrations: EvaluationFeedbackCalibration[] = [

];